import MedicationConflict from './MedicationConflict';

export default MedicationConflict;
